import { BASE_URL } from "../constants";
import { getAuthHeader } from "../utils";

export async function getImagenmedCosts(medicalCenterId) {
  if (!medicalCenterId) {
    throw new Error("Debe seleccionar un centro médico");
  }

  const params = new URLSearchParams();
  params.append("medical_center", medicalCenterId);

  const response = await fetch(
    `${BASE_URL}insurance/imagenmed-costs/?${params.toString()}`,
    {
      headers: {
        ...getAuthHeader(),
      },
    }
  );

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.detail || `HTTP ${response.status}`);
  }

  return response.json();
}

export async function updateImagenmedCosts({ medicalCenterId, items }) {
  if (!medicalCenterId) {
    throw new Error("Debe seleccionar un centro médico");
  }

  const params = new URLSearchParams();
  params.append("medical_center", medicalCenterId);

  const response = await fetch(
    `${BASE_URL}insurance/imagenmed-costs/?${params.toString()}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        ...getAuthHeader(),
      },
      body: JSON.stringify({ items }),
    }
  );

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.detail || `HTTP ${response.status}`);
  }

  return response.json();
}
